import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppProviders from './AppProviders';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    {/* Note: Material-UI v4 + React 18 compatibility issue causes findDOMNode warnings.
        This is a known issue with Material-UI v4 internals using deprecated React APIs.
        Warning doesn't affect functionality. Fix: upgrade to MUI v5 when feasible. */}
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
